import { StateNode } from "@tldraw/editor";
class Pointing extends StateNode {
  static id = "pointing";
  onEnter(info) {
    const onlyEraseTopShape = info.accelKey;
    const currentPageShapesSorted = this.editor.getCurrentPageRenderingShapesSorted();
    const currentPagePoint = this.editor.inputs.getCurrentPagePoint();
    const erasing = /* @__PURE__ */ new Set();
    const initialSize = erasing.size;
    for (let n = currentPageShapesSorted.length, i = n - 1; i >= 0; i--) {
      const shape = currentPageShapesSorted[i];
      if (this.editor.isShapeOrAncestorLocked(shape) || this.editor.isShapeOfType(shape, "group")) {
        continue;
      }
      if (this.editor.isPointInShape(shape, currentPagePoint, {
        hitInside: false,
        margin: this.editor.getHitTestMargin()
      })) {
        const hitShape = this.editor.getOutermostSelectableShape(shape);
        if (this.editor.isShapeFrameLike(hitShape) && erasing.size > initialSize) {
          break;
        }
        erasing.add(hitShape.id);
        if (onlyEraseTopShape) break;
      }
    }
    this.editor.setErasingShapes([...erasing]);
  }
  onLongPress(info) {
    if (info.accelKey) return;
    this.startErasing(info);
  }
  onExit(_info, to) {
    if (to !== "erasing") {
      this.editor.setErasingShapes([]);
    }
  }
  onPointerMove(info) {
    if (this.editor.inputs.getIsDragging()) {
      this.startErasing(info);
    }
  }
  onPointerUp(info) {
    this.complete(info);
  }
  onCancel() {
    this.cancel();
  }
  onComplete() {
    this.complete();
  }
  onInterrupt() {
    this.cancel();
  }
  startErasing(info) {
    this.parent.transition("erasing", info);
  }
  complete(info) {
    const erasingShapeIds = this.editor.getErasingShapeIds();
    if (erasingShapeIds.length) {
      this.editor.markHistoryStoppingPoint("erase end");
      this.editor.deleteShapes(erasingShapeIds);
    }
    this.parent.transition("idle", info);
  }
  cancel() {
    this.parent.transition("idle");
  }
}
export {
  Pointing
};
//# sourceMappingURL=Pointing.mjs.map
